import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { TopBar } from "./components/Topbar";
import { Footer } from "../Footer";

import '../../../../assets/scss/layout.css';

const useStyles = makeStyles(() => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  content: {
    height: "auto",
    marginBottom: "15px",
  },
  imgContainer: {
    display: "flex",
    width: "100%",
    height: "100%",
    position: "absolute",
    flexDirection: "row",
    justifyContent: "flex-end",
    "pointer-events": "none"
  },
  img: {
    display: "flex",
    width: "100%",
    opacity: "1",
    height:  "92.9%",
    zIndex: "-1",
    position: "fixed",
    marginTop: "100px",
    right: "0px",
    clipPath: "polygon(0% 0, 100% 0, 100% 100%, 0 100%)",
    bottom: "0",
    backgroundSize: "100%",
    backgroundPosition: "top",
    backgroundRepeat: 'no-repeat',
  },
  footer: {
    marginBottom: "-12px",
  },
}));

export const Minimal = (props) => {
  const { children, image } = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.imgContainer}>
        {image != null && <div style={{backgroundImage: 'url('+image+')'}} className="img" alt={""} />}
      </div>
      <TopBar />
      <main className={classes.content}>{children}</main>
      <Footer />
    </div>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  image: PropTypes.string,
};


